'use client';

import Image from 'next/image';

import { FOOTER_CONFIG } from '@eliadmin/core/src/constants/footer-config';
import { Paragraph } from '../../ui/paragraph';
import { MdOutlineLock } from 'react-icons/md';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ProductPaymentMethods() {
  const { t } = useTranslations();

  return (
    <div className="hidden w-full flex-wrap items-center justify-start gap-2 sm:flex">
      <div className="flex items-center justify-center gap-2">
        {FOOTER_CONFIG?.payment_methods?.map(method => (
          <Image
            key={method?.name}
            src={method?.icon}
            alt={method?.name}
            width={54}
            height={28}
            className="shrink-0 object-contain object-center"
          />
        ))}
      </div>
      <div className="flex items-center justify-center gap-2">
        <MdOutlineLock size={16} className="text-[#6B7280]" />
        <Paragraph size="sm" color="neutral">
          {t('text3849')}
        </Paragraph>
      </div>
    </div>
  );
}
